import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CarnivalShell from './CarnivalShell';

// Title screen (index.php): the animated intro and a Play Now button that opens the games hub.
// The PHP page also moved on by itself 12 seconds after a successful login.
export default function CarnivalIntro() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate('/carnival/games'), 12000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <CarnivalShell className="cc-intro">
      <img className="cc-intro-art cc-desk" src="/carnival/img/CC_2_Main.gif" alt="Christmas Carnival 2.0" />
      <img className="cc-intro-art cc-mob" src="/carnival/img/mobile_intro-CC2.gif" alt="Christmas Carnival 2.0" />
      <button type="button" className="cc-intro-play" onClick={() => navigate('/carnival/games')}>
        <img src="/carnival/img/PLaynow.png" alt="Play now" />
      </button>
    </CarnivalShell>
  );
}
